import { render, staticRenderFns } from "./CardTotalEvents.vue?vue&type=template&id=0a1a2bca&scoped=true&"
import script from "./CardTotalEvents.vue?vue&type=script&lang=js&"
export * from "./CardTotalEvents.vue?vue&type=script&lang=js&"
import style0 from "./CardTotalEvents.vue?vue&type=style&index=0&id=0a1a2bca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1a2bca",
  null
  
)

export default component.exports